import styled from 'styled-components'

export const RootCountBox = styled.div`
  display: flex;
  align-items: center;
`
